export default __webpack_public_path__ + "static/media/Acolyte's Leggings of the Spilling Blood.560bac16.jpg";